export const FOCUSABLE_TREE_ROOT_KEY = "__FOCUSABLE_TREE_ROOT__";
